import { withScalars } from "apollo-link-scalars";
import * as DateFns from "date-fns";
import introspectionResult from "generated/graphql.schema.json";
import { buildClientSchema, IntrospectionQuery } from "graphql";
import { formatISODate } from "Tools";

export type DateGraphQL = Date;

export type DateTimeGraphQL = Date;

const schema = buildClientSchema(
  introspectionResult as unknown as IntrospectionQuery,
);

export const scalarLink = withScalars({
  schema,
  typesMap: {
    Date: {
      serialize: formatISODate,
      parseValue: (value: string) =>
        DateFns.startOfDay(DateFns.parseISO(value)),
    },
    DateTime: {
      serialize: DateFns.formatISO,
      parseValue: DateFns.parseISO,
    },
  },
});
